/**
 * ADR-017 Fase 4 — stubs de estado local de sync.
 *
 * Sin SQLite no hay tablas locales con columna `synced`. Todas las
 * escrituras son online. Estas funciones son no-ops para los callers
 * que aún las referencian (flushRpc, repair, command RPCs).
 */
export async function markLocalExpenseSynced(_expenseId: string): Promise<void> {}
export async function markLocalExpenseSettlementSynced(_settlementId: string): Promise<void> {}
export async function markLocalCashSessionSynced(_sessionId: string): Promise<void> {}
export async function markLocalCashOutflowSynced(_outflowId: string): Promise<void> {}
export async function markLocalExternalServiceSynced(_operationId: string): Promise<void> {}
export async function markLocalPurchaseOrderSynced(_purchaseOrderId: string): Promise<void> {}
export async function markLocalPurchaseReceptionSynced(_receptionId: string): Promise<void> {}
export async function markLocalPurchaseReturnSynced(_returnId: string): Promise<void> {}
